import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllOrganizationUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllOrganization/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrganizationUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllOrganizationUser;
};


const setActiveOrganization = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setOrganizationActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrganizationUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Organization  - ',response);


    return AllOrganizationUser;
};



const setDeletedOrganization = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setOrganizationDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrganizationUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Organization  - ',response);


    return AllOrganizationUser;
};




const setUpdateOrganization = async (dataOrganizationUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setOrganizationUpdate/'),{
        dataOrganizationUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrganizationUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Organization  - ',dataOrganizationUpdate,response);


    return AllOrganizationUser;
};


const setSaveNewOrganization = async (dataOrganizationUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewOrganization/'),{
        dataOrganizationUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllOrganizationUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Organization  - ',response, dataOrganizationUpdate);


    return AllOrganizationUser;
};

Mock.onGet('/api/reference/getAllOrganization').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllOrganizationUser = await getAllOrganizationUser();
    // console.log('С сервера пришло - ', AllOrganizationUser);

    // if (!AllOrganizationUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllOrganizationUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOrganizationUser,
    ]


})


Mock.onPost('/api/reference/setActiveOrganization').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllOrganizationUser = await setActiveOrganization(id,val);

    // if (!AllOrganizationUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllOrganizationUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOrganizationUser,
    ]


})

Mock.onPost('/api/reference/setDeletedOrganization').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllOrganizationUser = await setDeletedOrganization(id,val);

    // if (!AllOrganizationUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllOrganizationUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOrganizationUser,
    ]


})


Mock.onPost('/api/reference/setUpdateOrganization').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataOrganizationUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Organization = await setUpdateOrganization(dataOrganizationUpdate);

    // console.log('Серовер вернул данные ',AllOrganizationUser);

    // if (!Organization) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Organization) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Organization,
    ]


})


Mock.onPost('/api/reference/setSaveNewOrganization').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataOrganizationUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Organization = await setSaveNewOrganization(dataOrganizationUpdate);

    // console.log('Серовер вернул данные ',AllOrganizationUser);

    // if (!Organization) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Organization) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Organization,
    ]
})